import React, { useState,useEffect, useRef  } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Password } from "primereact/password";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import { Toast } from 'primereact/toast';
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { Col, Form, Row } from 'react-bootstrap';
import FaDate from '../shared/FaDate';
import ShowVideo from '../shared/ShowVideo';

export default function RequestMembership (props) {
    const toast = useRef(null);
    const [panelRequestVisible, setPanelRequestVisible] = useState(true);
    const [panelSavePasswoerdVisible, setPanelSavePasswoerdVisible] = useState(false);
    const [nationalId, setNationalId] = useState("");
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [organizationCode, setOrganizationCode] = useState("");
    const [schoolName, setSchoolName] = useState("");
    const [province, setProvince] = useState("");
    const [city, setCity] = useState("");
    const [address, setAddress] = useState("");
    const [maxStudent, setMaxStudent] = useState();
    const [mobile, setMobile] = useState("");
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [saving, setSaving] = useState(false);
    const [btnOkVisible, setBtnOkVisible] = useState(true);
    const [smsCode, setSmsCode] = useState(0);
    const [smsMobile, setSmsMobile] = useState("");
    const [smsNationalId, setSmsNationalId] = useState("");
    const [birthDate, setBirthDate] = useState(0);

    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "nationalId") setNationalId(val);
        else if(name === "organizationCode") setOrganizationCode(val);
        else if(name === "schoolName") setSchoolName(val);
        else if(name === "province") setProvince(val);
        else if(name === "city") setCity(val);
        else if(name === "address") setAddress(val);
        else if(name === "maxStudent") setMaxStudent(val);
        else if(name === "mobile") setMobile(val);
        else if(name === "firstname") setFirstname(val);
        else if(name === "lastname") setLastname(val);
        else if(name === "smsCode") {
            if(val == null) val = "0";
            if(val == "") val = "0";
            setSmsCode(parseInt(val));
        }
    }
    const checkDataEntry = function(){    
        // if(smsCode <= 0){
        //     setErrorMessage("قبل از ثبت درخواست، کد پیامک شده را وارد کنید");
        //     setErorVisible(true);
        //     return false;
        // }
        // if(smsNationalId.trim().length == 0){
        //     setErrorMessage("کد ملی را وارد کنید");
        //     setErorVisible(true);
        //     return false;
        // }
        // if(smsNationalId.trim() != nationalId.trim()){
        //     setErrorMessage("کد ملی با کد ملی پیامک شده مغایرت دارد");
        //     setErorVisible(true);
        //     return false;
        // }
        // if(smsMobile.trim().length == "" ){
        //     setErrorMessage("شماره موبایل را وارد کنید");
        //     setErorVisible(true);
        //     return false;
        // }
        // if(smsMobile.trim() != mobile.trim()){
        //     setErrorMessage("موبایل با موبایل پیامک شده مغایرت دارد");
        //     setErorVisible(true);
        //     return false;
        // }
        if(organizationCode.trim().length != 8){
            setErrorMessage("کد 8 رقمی واحد سازمانی را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(schoolName.trim().length == "" ){
            setErrorMessage("نام مدرسه وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(province.trim().length == "" ){
            setErrorMessage("استان را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(city.trim().length == "" ){
            setErrorMessage("شهر را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(address.trim().length == "" ){
            setErrorMessage("آدرس را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(nationalId.trim().length == 0){
            setErrorMessage("کد ملی را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(mobile.trim().length == "" ){
            setErrorMessage("شماره تلفن را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(birthDate<=0){
            console.log("birth date is>", birthDate)
            setErorVisible(true);
            setErrorMessage("تاریخ تولد را مشخص نمائید");
            return false;
        }
        if(firstname.trim().length == "" ){
            setErrorMessage("نام را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(lastname.trim().length == "" ){
            setErrorMessage("نام خانوادگی را وارد کنید");
            setErorVisible(true);
            return false;
        }

        if(maxStudent === ""){
            setErrorMessage("حداکثر تعداد دانش آموز را وارد کنید");
            setErorVisible(true);
            return false;
        }   
        return true;
    }
    const saveRequestMemberShip = function(){
        if(!checkDataEntry()) return;
        setSaving(true);
        var params = {nationalId:nationalId, organizationCode:organizationCode, schoolName:schoolName, 
            province:province, city:city, address:address, maxStudent:maxStudent, 
            mobile:mobile, firstname:firstname, lastname:lastname,smsCode:smsCode,birthDate:birthDate,
            agentCode:util.getAgentCode()
        }
        var url = config.Server+`/user/school/membership/request`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);
                    setErorVisible(true);
                    setErrorMessage(response);
                    toast.current.show({ severity: 'info', summary: 'Info', detail: 'با موفقیت ثبت شد' });  
                    setBtnOkVisible(false);  
                    setSaving(false);                
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false); 
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false); 
            });
    }
     const codeRuquest = function(){
        if(nationalId.trim().length < 10){
            setErrorMessage("کد ملی را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(mobile.trim().length == "" ){
            setErrorMessage("شماره موبایل را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(!util.IsMobileValid(mobile)){
            setErrorMessage("شماره موبایل معتبر نمی باشد");
            setErorVisible(true);
            return false;
        }
        setSaving(true);
        var params = {nationalId:nationalId, mobile:mobile}
        var url = config.Server+`/user/public/membership/request/code`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    setSmsMobile(mobile);
                    setSmsNationalId(nationalId);
                    response = response.data;
                    console.log("response is>", response);
                    toast.current.show({ severity: 'info', summary: 'Info', detail: 'ارسال شد' });                    
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false); 
                }
                setSaving(false);
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });
    }
   return(
        <>
        {
        (redirectUrl != "")
        ?
        <Navigate to={redirectUrl} replace={false}  />
        :
        (panelRequestVisible)? 
        <> 
        <ShowVideo videoId="school_membership" top={10} md={12} />
        <div style={{width:"100%"}} className='justify-content-center'>
            <div style={{width:"100%", padding:"5px 20px 20px 20px", height:"calc(100vh - 10px)", overflowY:"scroll"}}>
                <Row>
                    <Col style={{textAlign:"center"}} >
                        <span style={{fontSize:"4em"}} className="pi pi-user-plus"></span>
                        <br/>
                        <span style={{fontSize:"14pt"}}>درخواست عضویت مدرسه</span>                         
                    </Col>
                </Row>
                <Row style={{marginTop:"25px"}}>
                    <Col style={{textAlign:"center"}} >
                        <FloatLabel>
                            <InputText value={organizationCode} onChange={(e)=>{onInputChange(e, "organizationCode")}} id="organizationCode" keyfilter="int" maxLength={8} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                            <label htmlFor="username">کد واحد سازمانی</label>
                        </FloatLabel>
                    </Col>
                </Row>
                <Row style={{marginTop:"5px"}}>
                    <Col style={{textAlign:"center", color:"#a0a0a0", fontSize:"8pt", textAlign:"right"}} >
                    منظور از کد واحد سازمانی همان کد 8 رقمی واحد سازمانی در آموزش و پرورش می باشد
                    </Col>
                </Row>
                <Row style={{marginTop:"25px"}}>
                    <Col style={{textAlign:"center"}} >
                        <FloatLabel>
                            <InputText value={schoolName} onChange={(e)=>{onInputChange(e, "schoolName")}} id="schoolName" keyfilter="" maxLength={100} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                            <label htmlFor="username">نام مدرسه</label>
                        </FloatLabel>
                    </Col>
                </Row>
                <Row style={{marginTop:"25px"}}>
                    <Col style={{textAlign:"center"}} >
                        <FloatLabel>
                            <InputText value={province} onChange={(e)=>{onInputChange(e, "province")}} id="province" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                            <label htmlFor="username">استان</label>
                        </FloatLabel>
                    </Col>
                </Row>
                <Row style={{marginTop:"25px"}}>
                    <Col style={{textAlign:"center"}} >
                        <FloatLabel>
                            <InputText value={city} onChange={(e)=>{onInputChange(e, "city")}} id="city" keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                            <label htmlFor="username">شهر</label>
                        </FloatLabel>
                    </Col>
                </Row>
                <Row style={{marginTop:"25px"}}>
                    <Col style={{textAlign:"center"}} >
                        <FloatLabel>
                            <InputText value={address} onChange={(e)=>{onInputChange(e, "address")}} id="address" keyfilter="" maxLength={250} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                            <label htmlFor="username">آدرس</label>
                        </FloatLabel>
                    </Col>
                </Row>
                <Row style={{marginTop:"25px"}}>
                    <Col style={{textAlign:"center"}} >
                        <FloatLabel>
                            <InputText value={maxStudent} onChange={(e)=>{onInputChange(e, "maxStudent")}} id="maxStudent" keyfilter="int" maxLength={4} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                            <label htmlFor="username">حداکثر دانش آموز</label>
                        </FloatLabel>
                    </Col>
                </Row>
                <Row style={{marginTop:"25px"}}>
                    <Col style={{textAlign:"center", backgroundColor:"royalblue", color:"#fff", padding:"5px"}} >
                    مشخصات مدیر مدرسه
                    </Col>
                </Row>
                <Row style={{marginTop:"10px"}}>
                    <Col style={{textAlign:"center", textAlign:"right"}} >
                        <label style={{backgroundColor:"#ff0", color:"#f00"}}>بسیار مهم:</label>
                        <br/>
                        کد ملی، موبایل و تاریخ تولد با دقت ثبت شوند.  در صورت اشکال در این مقادیر، فعال سازی پنل پیامکی برای شما با مشکل مواجه خواهد شد.
                        <br/>                    
                        <label style={{backgroundColor:"rgba(239, 248, 239, 1)", color:"#f00", padding:"5px", borderRadius:"5px"}}>شماره همراه در سیستم مخابرات باید برای همین کد ملی ثبت شده باشد</label>
                    </Col>
                </Row>
                <Row style={{marginTop:"25px"}}>
                    <Col style={{textAlign:"center"}} >
                        <FloatLabel>
                            <InputText value={nationalId} onChange={(e)=>{onInputChange(e, "nationalId")}} id="nationalId" keyfilter="int" maxLength={12} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                            <label htmlFor="username">کد ملی</label>
                        </FloatLabel>
                    </Col>
                </Row>
                <Row style={{marginTop:"25px"}}>
                    <Col style={{textAlign:"center"}} >
                        <FloatLabel>
                            <InputText value={mobile} onChange={(e)=>{onInputChange(e, "mobile")}} id="mobile" keyfilter="int" maxLength={11} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                            <label htmlFor="username">موبایل</label>
                        </FloatLabel>
                    </Col>
                </Row>
                <Row>
                    <Col sd={2} style={{paddingTop:"11px"}}>
                        تاریخ تولد:
                        <br/>
                        <FaDate value={0} onChange={(val)=>{setBirthDate(val);console.log("data is>", val)}} />
                    </Col>
                </Row>
                {/* <Row style={{marginTop:"25px"}}>
                    <Col style={{textAlign:"center"}} >
                        <FloatLabel>
                            <InputText value={smsCode} onChange={(e)=>{onInputChange(e, "smsCode")}} id="smsCode" keyfilter="int" maxLength={6} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                            <label htmlFor="username">کد پیامک</label>
                        </FloatLabel>
                    </Col>
                    <Col style={{textAlign:"center"}} >
                        <Button loading={saving} label="درخواست کد" onClick={()=>codeRuquest()} severity="success" iconPos="right" style={{height:"50px", width:"150px"}} />
                    </Col>
                </Row> */}
                <Row style={{marginTop:"25px"}}>
                    <Col style={{textAlign:"center"}} >
                        <FloatLabel>
                            <InputText value={firstname} onChange={(e)=>{onInputChange(e, "firstname")}} id="firstname" keyfilter="" maxLength={25} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                            <label htmlFor="username">نام</label>
                        </FloatLabel>
                    </Col>
                </Row>
                <Row style={{marginTop:"25px"}}>
                    <Col style={{textAlign:"center"}} >
                        <FloatLabel>
                            <InputText value={lastname} onChange={(e)=>{onInputChange(e, "lastname")}} id="lastname" keyfilter="" maxLength={25} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                            <label htmlFor="username">نام خانوادگی</label>
                        </FloatLabel>
                    </Col>
                </Row>
                <Row style={{marginTop:"25px"}}>
                    <Col style={{textAlign:"center"}} >
                        <div className="card flex justify-content-center" style={{ direction: "ltr" }}>
                            <Button visible={btnOkVisible} loading={saving} label="ثبت درخواست عضویت مدرسه" icon="pi pi-check" onClick={()=>saveRequestMemberShip()} severity="success" iconPos="right" />
                        </div>
                    </Col>
                </Row>
                <Row style={{marginTop:"25px"}}>
                    <Col style={{textAlign:"center"}} >
                        <Link to="/login" style={{textDecoration:"none", color:"#a0a0a0"}}>برگشت</Link>
                    </Col>
                </Row>
            </div>
        </div> 
        </>
        :
        <></>
        }
        <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        <Toast ref={toast} />  
        </>
    );
}
